import { Section } from '@/typings/pages';

export const extractSection = (
  sections: Section[] | undefined,
  type: string
): Section | [] => {
  try {
    if (!Array.isArray(sections)) {
      console.error('Expected sections to be an array');
      return [];
    }
    return sections.find((item) => item.type === type) || [];
  } catch (error) {
    console.error('Error in extractSection:', error);
    return [];
  }
};
